import React, { createContext, useCallback, useMemo, useRef } from 'react';
import modalPreview from '../modal/preview';
const PictureContext = createContext(undefined);
export default PictureContext;
export const PictureProvider = (props) => {
    const { children } = props;
    const pictureList = useRef([]);
    const registerPicture = useCallback((index, pictureRef) => {
        if (pictureList.current[index] !== pictureRef) {
            pictureList.current[index] = pictureRef;
        }
    }, [pictureList]);
    const unRegisterPicture = useCallback((index, pictureRef) => {
        if (pictureList[index] === pictureRef) {
            pictureList.current[index] = undefined;
        }
    }, [pictureList]);
    const preview = useCallback((index) => {
        modalPreview({
            defaultIndex: index,
            list: pictureList.current.reduce((items, picture) => {
                if (picture && picture.src) {
                    items.push(picture.src);
                }
                return items;
            }, []),
        });
    }, [pictureList]);
    const value = useMemo(() => ({
        registerPicture,
        unRegisterPicture,
        preview,
    }), [registerPicture, unRegisterPicture, preview]);
    return (React.createElement(PictureContext.Provider, { value: value }, children));
};
